import React from 'react';
import {Typography} from "@material-ui/core";

const FBPagination = ({current_page, total_pages, handleFetchPage}) => {
    return (
        <div className='flex flex-row items-center space-x-2'>
            <Typography className='cursor-pointer'
                        onClick={() => handleFetchPage(1)}
                        color={current_page === 1 ? 'textSecondary' : 'primary'}>First</Typography>
            <Typography className='cursor-pointer'
                        onClick={() => handleFetchPage(current_page - 1)}
                        color={current_page === 1 ? 'textSecondary' : 'primary'}>Prev</Typography>
            <Typography className='cursor-pointer' color={"textSecondary"}>{current_page}</Typography>
            <Typography className='cursor-pointer'
                        onClick={() => handleFetchPage(current_page + 1)}
                        color={current_page === total_pages ? 'textSecondary' : 'primary'}>Next</Typography>
            <Typography className='cursor-pointer'
                        onClick={() => handleFetchPage(total_pages)}
                        color={current_page === total_pages ? 'textSecondary' : 'primary'}>Last</Typography>

        </div>

    )
}

export default FBPagination;